import { useQuery } from '@tanstack/react-query';
import { type VesselTrackViewModel } from '../components/Map/types';
import { apiClient } from '../services/ApiClient';
import { ApiEndpoints } from '../constants/api-constants';
import { Queries, QueryCacheConfig } from '../constants/query-constants';

const useHoveredVesselTracks = (operation: string, tripId: string, jobId: string): VesselTrackViewModel[] => {
  const getJobVesselTracks = async (): Promise<VesselTrackViewModel[]> => {
    return apiClient.get<VesselTrackViewModel[]>(ApiEndpoints.trips.getJobVesselTracks(operation, tripId, jobId));
  };

  return useQuery({
    ...QueryCacheConfig[Queries.JobVesselTracks],
    queryKey: [Queries.JobVesselTracks, operation, tripId, jobId],
    queryFn: getJobVesselTracks,
    enabled: !!tripId && !!jobId,
  }).data;
};

export default useHoveredVesselTracks;
